/* A Minha Terra page behaviour: the live frame, the village answer, the questions, validation, the bottom bar.
   No dependencies. Reads the villages with a photograph from #amt-villages and every string from the <template> elements.
   Everything about the caption is optional: a line the buyer leaves blank is left off the frame, not shown as a blank.
   The price is never typed here: it comes from the variant (data-price on the format choice), already formatted by the server. */
(function () {
  'use strict';
  var root = document.documentElement; root.classList.add('js');

  function boot() {
    var A = document.getElementById('amt');
    if (A && !A.__amt) { A.__amt = true; init(A); }
  }
  boot();
  // the theme editor re-draws the section when a setting changes: start again on the new markup
  document.addEventListener('shopify:section:load', boot);

  function init(A) {
    function $(id) { return document.getElementById(id); }
    function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
    function tpl(id) { var t = $(id); return t ? (t.content ? t.content.textContent : t.textContent).trim() : ''; }
    // one pass, so a "$&" or "{n}" typed by a visitor can never be read as part of the template
    function fill(str, map) { return str.replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
    var NB = String.fromCharCode(160);
    var MARKS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
    var L = (A.getAttribute('data-lang') || root.lang || 'pt').slice(0, 2) === 'fr' ? 'fr' : 'pt';
    var YEAR = parseInt(A.getAttribute('data-year'), 10) || new Date().getFullYear();   // the year printed for a village not photographed yet comes from the server
    var SYM = A.getAttribute('data-symbol') || '€';
    var narrow = window.matchMedia ? window.matchMedia('(max-width: 899.98px)') : { matches: false };

    /* ---------- data ---------- */
    var VILLAGES = [];
    try { VILLAGES = JSON.parse(($('amt-villages') || {}).textContent || '[]'); } catch (e) { VILLAGES = []; }
    var CITIES = [
      ['Champigny-sur-Marne', 48.8172, 2.5156, ['champigny']], ['Paris', 48.8566, 2.3522], ['Saint-Maur-des-Fossés', 48.7939, 2.4936, ['saint maur', 'st maur']],
      ['Créteil', 48.7904, 2.4556], ['Vitry-sur-Seine', 48.7875, 2.3928, ['vitry']], ['Ivry-sur-Seine', 48.8157, 2.3849, ['ivry']], ['Montreuil', 48.8638, 2.4485],
      ['Nanterre', 48.8924, 2.2071], ['Argenteuil', 48.9472, 2.2467], ['Versailles', 48.8049, 2.1204], ['Boulogne-Billancourt', 48.8397, 2.2399, ['boulogne']],
      ['Saint-Denis', 48.9362, 2.3574], ['Aulnay-sous-Bois', 48.9386, 2.4973, ['aulnay']], ['Sarcelles', 48.9973, 2.3790], ['Cergy', 49.0364, 2.0761],
      ['Évry', 48.6290, 2.4406, ['evry courcouronnes']], ['Massy', 48.7308, 2.2713], ['Villeneuve-Saint-Georges', 48.7325, 2.4497], ['Villiers-sur-Marne', 48.8242, 2.5453],
      ['Lyon', 45.7640, 4.8357], ['Marseille', 43.2965, 5.3698], ['Toulouse', 43.6047, 1.4442], ['Bordeaux', 44.8378, -0.5792], ['Lille', 50.6292, 3.0573],
      ['Strasbourg', 48.5734, 7.7521], ['Nantes', 47.2184, -1.5536], ['Tours', 47.3941, 0.6848], ['Orléans', 47.9030, 1.9093], ['Clermont-Ferrand', 45.7772, 3.0870],
      ['Grenoble', 45.1885, 5.7245], ['Nice', 43.7102, 7.2620], ['Rouen', 49.4432, 1.0999], ['Reims', 49.2583, 4.0317], ['Rennes', 48.1173, -1.6778],
      ['Montpellier', 43.6108, 3.8767], ['Dijon', 47.3220, 5.0415], ['Metz', 49.1193, 6.1757], ['Annecy', 45.8992, 6.1294], ['Chambéry', 45.5646, 5.9178],
      ['Le Mans', 48.0061, 0.1996], ['Poitiers', 46.5802, 0.3404], ['Limoges', 45.8336, 1.2611], ['Pau', 43.2951, -0.3708], ['Bayonne', 43.4929, -1.4748], ['Mulhouse', 47.7508, 7.3359],
      ['Luxembourg', 49.6116, 6.1319, ['luxemburgo', 'luxemburg', 'luxembourg ville', 'cidade do luxemburgo']], ['Esch-sur-Alzette', 49.4958, 5.9806, ['esch']], ['Differdange', 49.5242, 5.8914],
      ['Dudelange', 49.4806, 6.0875], ['Pétange', 49.5586, 5.8806], ['Ettelbruck', 49.8475, 6.1042], ['Diekirch', 49.8672, 6.1597], ['Wiltz', 49.9661, 5.9322], ['Mersch', 49.7489, 6.1061],
      ['Genève', 46.2044, 6.1432, ['genebra', 'geneve', 'geneva']], ['Lausanne', 46.5197, 6.6323, ['lausana']], ['Sion', 46.2331, 7.3606], ['Fribourg', 46.8065, 7.1620, ['friburgo']],
      ['Zurich', 47.3769, 8.5417, ['zurique']], ['Neuchâtel', 46.9900, 6.9293], ['Berne', 46.9480, 7.4474, ['berna', 'bern']], ['Stuttgart', 48.7758, 9.1829, ['estugarda']],
      ['Frankfurt', 50.1109, 8.6821, ['francoforte', 'francfort']], ['Hamburg', 53.5511, 9.9937, ['hamburgo', 'hambourg']], ['Bruxelles', 50.8503, 4.3517, ['bruxelas', 'brussels']],
      ['Londres', 51.5074, -0.1278, ['london', 'londres']], ['Lisboa', 38.7223, -9.1393, ['lisbonne', 'lisbon']], ['Porto', 41.1579, -8.6291], ['Braga', 41.5454, -8.4265], ['Coimbra', 40.2033, -8.4103]
    ];
    // The verb follows who the frame is for: me, one other person, two or more.
    var VERB = { '': 'Saíste em', mim: 'Saí em', um: 'Saíste em', varios: 'Saíram em' };
    var PHR = { coracao: 'O coração ficou.', longe: 'Longe da vista, perto do coração.', comecou: 'Onde tudo começou.' };
    var OLD_PARA = { 'pai-mae': 'um', pai: 'um', mae: 'um', outra: 'um', pais: 'varios' };
    var PARAS = ['mim', 'um', 'varios'], LEGS = ['historia', 'coracao', 'longe', 'comecou'];
    var EX_YEAR_LINE = 'Saíste em 1984.', EX_CITY = CITIES[0], EX_CITY_NAME = 'Champigny';
    // small words that stay lower case inside a name typed all in lower or all in upper case
    var SMALL = ['de', 'do', 'da', 'dos', 'das', 'e', 'du', 'des', 'la', 'le', 'les', 'sur', 'sous', 'en', 'et', 'd', 'l'];

    /* ---------- helpers ---------- */
    function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(MARKS, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
    function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, NB); }
    function money(p) { return p ? p + NB + SYM : ''; }
    // what the buyer typed in all lower or all upper case is printed with capitals; a name written with mixed case is left as written
    function titleCase(s) {
      s = String(s || '').trim();
      if (!s || (s !== s.toLowerCase() && s !== s.toUpperCase())) return s;
      return s.toLowerCase().replace(/(^|[\s\-'’])([^\s\-'’]+)/g, function (m, sep, w, i) {
        return sep + (i > 0 && SMALL.indexOf(w) > -1 ? w : w.charAt(0).toUpperCase() + w.slice(1));
      });
    }
    function km(a, b) {
      var R = 6371.0088, r = Math.PI / 180, dLat = (b[0] - a[0]) * r, dLon = (b[1] - a[1]) * r;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return Math.round(2 * R * Math.asin(Math.sqrt(h)));
    }
    function findCity(s) {
      var n = norm(s); if (!n) return null;
      for (var i = 0; i < CITIES.length; i++) { var c = CITIES[i]; if (norm(c[0]) === n || (c[3] || []).indexOf(n) > -1) return c; }
      return null;
    }
    function findVillage(name, place) {
      var n = norm(name); if (!n && !place) return null;
      for (var i = 0; i < VILLAGES.length; i++) {
        var v = VILLAGES[i], names = [v.name, v.freguesia].concat(v.aliases || []).map(norm);
        if (n && names.indexOf(n) > -1) return v;
        if (place && norm(place.f) === norm(v.freguesia) && norm(place.c) === norm(v.concelho)) return v;
      }
      return null;
    }
    // write only when the text really changed: a screen reader announces every rewrite, even of the same words
    function setIf(node, text) { if (node && node.textContent !== text) node.textContent = text; }
    function setText(node, text) {
      if (!node) return;
      if (node.textContent !== text) { node.textContent = text; node.classList.remove('swap'); void node.offsetWidth; node.classList.add('swap'); }
    }

    /* ---------- elements ---------- */
    var form = $('amt-form');
    var f = { v: $('amt-aldeia'), ano: $('amt-ano'), cid: $('amt-cidade') };
    var ui = {
      frame: $('frame'), wall: $('wall'), tag: $('frame-tag'), img: $('print-img'), slot: $('print-slot'), slotName: $('slot-name'),
      place: $('cap-place'), l1: $('cap-l1'), l2: $('cap-l2'), meta: $('frame-meta'), note: $('frame-note'),
      answer: $('amt-answer'), sugg: $('amt-sugg'), errAldeia: $('err-aldeia'), errPara: $('err-para'), errAno: $('err-ano'), banner: $('amt-banner'), share: $('amt-share'),
      fldAno: $('fld-ano'), two: $('two'), stepPara: $('step-para'), stepCap: $('step-cap'),
      last: $('amt-last'), lastH: $('last-h'), lastFind: $('amt-last-find'), lastOrder: $('amt-last-order'),
      dock: $('amt-dock'), dockOpen: $('dock-open'), dockImg: $('dock-img'), dockName: $('dock-name'), dockCap: $('dock-cap'),
      ex: $('amt-ex'), exList: $('amt-ex-list'), close: $('close'), closeImg: $('close-img'), closeShot: $('close-shot'), fmtSwitch: $('fmt-switch')
    };
    var state = { complete: false };
    var voiceTouched = false, place = null, yearTouched = false, exBtns = [];
    form.noValidate = true;   // the page checks the form itself; without a script the browser's own check still applies

    /* city suggestions */
    var dl = $('amt-cities'); if (dl) CITIES.forEach(function (c) { var o = document.createElement('option'); o.value = c[0]; dl.appendChild(o); });

    function para() { var r = form.querySelector('input[name="properties[Para quem]"]:checked'); return r ? r.getAttribute('data-k') : ''; }
    function capk() { var r = form.querySelector('input[name="properties[Tipo de legenda]"]:checked'); return r ? r.getAttribute('data-k') : 'historia'; }
    function fmtInput() { return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]'); }
    // the example under the field: the first photographed village, and a distance worked out from its own coordinates
    function exampleCityLine() {
      var v = VILLAGES[0];
      return v ? EX_CITY_NAME + ', ' + fmt(km([v.lat, v.lon], [EX_CITY[1], EX_CITY[2]])) + ' km.' : EX_CITY_NAME + '.';
    }

    /* ---------- what the frame says ---------- */
    function lines() {
      var vnameRaw = (f.v.value || '').trim(), typed = !!vnameRaw;
      var p = para(), k = capk();
      var anoRaw = (f.ano.value || '').replace(/\D/g, '').slice(0, 4), cidRaw = (f.cid.value || '').trim();
      var anoOk = /^\d{4}$/.test(anoRaw) && +anoRaw >= 1900 && +anoRaw <= YEAR;
      var ano = (k === 'historia' && anoOk) ? anoRaw : '';
      var anoBad = k === 'historia' && !!anoRaw && !anoOk;
      var vill = findVillage(vnameRaw, place), city = findCity(cidRaw), cid = titleCase(cidRaw);
      var vname = titleCase(vnameRaw);
      var verb = VERB[p] || VERB[''];
      var dist = vill && city ? km([vill.lat, vill.lon], [city[1], city[2]]) : null;
      var cityLine = cid ? cid + (dist ? ', ' + fmt(dist) + ' km' : '') + '.' : '';
      // Nothing touched yet: show an example. Anything touched: show only what has been filled in.
      var example = !(typed || anoRaw || cidRaw || p || k !== 'historia');
      var l1 = '', l2 = '';
      if (example) { l1 = EX_YEAR_LINE; l2 = exampleCityLine(); }
      else if (k === 'historia') { l1 = ano ? verb + ' ' + ano + '.' : ''; l2 = cityLine; }
      else { l1 = PHR[k] || ''; l2 = cityLine; }
      // Something a family wrote (a year or a city) is what makes the piece made to measure.
      var personal = !example && !!(ano || cid);
      return { vname: vname, typed: typed, example: example, vill: vill, dist: dist, ano: ano, anoBad: anoBad, cid: cid, k: k, p: p, l1: l1, l2: l2, cityLine: cityLine, verb: verb, personal: personal };
    }

    function missingList(s) {
      var m = [];
      if (!s.typed) m.push('village');
      if (s.ano && !s.p) m.push('para');      // the verb depends on who it is for, so it matters once a year is written
      if (s.anoBad) m.push('ano');
      return m;
    }

    /* The sentence under the village field. While suggestions are open it waits; while a name we do not know is still being typed it waits for a pause,
       so nothing is shown (or read aloud) for every letter. */
    var answerTimer = null;
    function paintAnswer(s) {
      var open = ui.sugg && !ui.sugg.hidden, a = '', cls = 'answer';
      if (s.typed && !(open && !s.vill)) {
        if (s.vill) a = fill(tpl('t-status-photo'), { v: s.vill.name, d: s.vill.date[L] });
        else if (A.getAttribute('data-trip') === '1' && place && norm(place.c) === norm(A.getAttribute('data-tripc'))) a = fill(tpl('t-status-trip'), { v: s.vname });
        else a = fill(tpl('t-status-wait'), { v: s.vname, n: A.getAttribute('data-extra') || '3' });
        cls = 'answer ok';
      }
      setIf(ui.answer, a);
      if (ui.answer.className !== cls) ui.answer.className = cls;
      ui.answer.hidden = !a;
    }
    function updateAnswer(s) {
      clearTimeout(answerTimer); s = s || lines();
      if (s.typed && !s.vill && !place && document.activeElement === f.v) { ui.answer.hidden = true; answerTimer = setTimeout(function () { paintAnswer(lines()); }, 650); return; }
      paintAnswer(s);
    }

    function render() {
      var s = lines(), fm = fmtInput(), isPrint = !!(fm && fm.getAttribute('data-k') === 'print');
      var exVill = s.example && VILLAGES.length ? VILLAGES[0] : null;
      var shown = s.vill || exVill;
      var quote = s.k !== 'historia';

      // labels that follow who it is for, and the year field that a phrase does not use
      form.setAttribute('data-voice', s.p);
      ui.stepCap.setAttribute('data-cap', s.k);
      if (ui.fldAno) ui.fldAno.hidden = quote;
      if (ui.two) ui.two.classList.toggle('is-one', quote);
      f.ano.disabled = quote;   // a year the caption does not use is not sent with the order

      // the frame
      ui.frame.setAttribute('data-fmt', isPrint ? 'print' : 'framed');
      ui.frame.setAttribute('data-state', s.example ? 'example' : 'yours');
      ui.frame.setAttribute('data-orient', shown && shown.orient === 'portrait' ? 'portrait' : 'landscape');
      setIf(ui.tag, s.example ? tpl('t-ex-tag') : (isPrint ? tpl('t-your-tag-print') : tpl('t-your-tag')));
      if (shown) {
        var u = shown.img['900'] || shown.img['1400'] || shown.img['600'];
        if (ui.img.getAttribute('src') !== u) ui.img.setAttribute('src', u);
        ui.img.alt = (shown.alt && shown.alt[L]) || ui.img.alt;
        ui.img.hidden = false; ui.slot.hidden = true;
      } else {
        ui.img.hidden = true; ui.slot.hidden = false;
        setIf(ui.slotName, s.typed ? s.vname : '');
      }
      var placeName = s.example ? (exVill ? exVill.name : tpl('t-ex-place')) : (s.vill ? s.vill.name : (s.typed ? s.vname : tpl('t-ex-place')));
      var placeYear = s.example ? (exVill ? exVill.year : YEAR) : (s.vill ? s.vill.year : YEAR);
      var placeLine = placeName + ', ' + placeYear;
      setText(ui.place, placeLine);
      setText(ui.l1, s.l1); ui.l1.hidden = !s.l1;
      setText(ui.l2, s.l2); ui.l2.hidden = !s.l2;
      var meta;
      if (s.example) meta = tpl('t-proof-ex');
      else if (s.vill) meta = fill(tpl(A.getAttribute('data-founder') === '1' ? 't-proof-by' : 't-proof-date'), { d: s.vill.date[L] });
      else meta = '';
      setIf(ui.meta, meta);
      var note = s.example ? '' : (s.dist != null ? tpl('t-dist-note') : (s.typed && s.cid ? tpl('t-note-nokm') : ''));
      setIf(ui.note, note); ui.note.hidden = !note;
      updateAnswer(s);

      // what each caption choice will print, with the buyer's own words once there are some
      qa('[data-sample]').forEach(function (n) {
        var key = n.getAttribute('data-sample'), txt = '', hint = false;
        if (key === 'historia') {
          txt = [s.ano ? s.verb + ' ' + s.ano + '.' : '', s.cityLine].filter(Boolean).join('\n');
          if (!txt) { txt = tpl('t-story-hint'); hint = true; }
        } else { txt = s.cityLine; }
        setIf(n, txt); n.classList.toggle('is-hint', hint);
      });

      // price (as the server wrote it, from the variant), buttons, what is missing
      var price = fm ? (fm.getAttribute('data-price') || '') : '';
      qa('.js-sum-name').forEach(function (n) { setIf(n, tpl(isPrint ? 't-sum-print' : 't-sum-framed')); });
      qa('.js-sum-price').forEach(function (n) { setIf(n, money(price)); });
      qa('.js-order-label').forEach(function (n) { setIf(n, fill(tpl('t-btn'), { p: money(price) }).trim()); });
      qa('button', ui.fmtSwitch || document.createElement('div')).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-fmt') === (isPrint ? 'print' : 'framed'))); });
      var miss = missingList(s), names = { village: tpl('t-m-village'), para: tpl('t-m-para'), ano: tpl('t-m-ano') };
      var msg = s.example ? '' : (miss.length ? tpl('t-m-prefix') + ' ' + miss.map(function (x) { return names[x]; }).join(', ') + '.' : tpl('t-m-ok'));
      qa('.js-missing').forEach(function (n) { setIf(n, msg); n.classList.toggle('is-ok', !miss.length && !s.example); });
      state.complete = !miss.length;
      // the withdrawal sentence that is true now: made to measure once a family wrote something, the ordinary 14 days before that
      qa('.js-legal').forEach(function (n) { n.hidden = !s.personal; });
      qa('.js-legal-default').forEach(function (n) { n.hidden = s.personal; });

      // hidden fields the order carries
      var caption = [placeLine, s.l1, s.l2].filter(Boolean).join('\n');
      var set = function (id, v) { var n = $(id); if (n) n.value = v; };
      set('p-legenda', state.complete ? caption : '');
      set('p-escolheu', voiceTouched ? '1' : '0');
      if (place) { set('p-freg', place.f); set('p-conc', place.c); set('p-dist', place.d); }
      else if (s.vill) { set('p-freg', s.vill.freguesia); set('p-conc', s.vill.concelho); set('p-dist', s.vill.distrito); }
      else { set('p-freg', ''); set('p-conc', ''); set('p-dist', ''); }

      // the village up close, only for a village that has its own photograph
      if (ui.close) {
        var showClose = !!(s.vill && s.vill.img.detail);
        ui.close.hidden = !showClose;
        if (showClose) {
          if (ui.closeImg.getAttribute('src') !== s.vill.img.detail) ui.closeImg.setAttribute('src', s.vill.img.detail);
          ui.closeImg.alt = (s.vill.alt && s.vill.alt[L]) || '';
          ui.close.setAttribute('data-orient', s.vill.orient === 'portrait' ? 'portrait' : 'landscape');
          var founder = A.getAttribute('data-founder') === '1';
          ui.closeShot.hidden = !founder;
          if (founder) setIf(ui.closeShot, fill(tpl('t-shot-line'), { d: s.vill.date[L] }));
        }
      }

      // the strip of photographed villages: the one that is on show is the pressed one
      exBtns.forEach(function (e) { e.b.setAttribute('aria-pressed', String(!!s.vill && s.vill.id === e.v.id)); });

      // last call, share, the bar at the bottom
      if (ui.lastH) setIf(ui.lastH, s.typed ? fill(tpl('t-last-yours'), { v: s.vname }) : tpl('t-last-h'));
      if (ui.lastFind) ui.lastFind.hidden = s.typed;
      if (ui.lastOrder) ui.lastOrder.hidden = !s.typed;
      if (ui.share) ui.share.hidden = !(state.complete && s.personal);
      if (ui.dockName) setIf(ui.dockName, s.typed ? placeLine : '');
      if (ui.dockCap) setIf(ui.dockCap, [s.l1, s.l2].filter(Boolean).join(' '));
      if (ui.dockImg) {
        if (shown && !s.example) { ui.dockImg.style.backgroundImage = 'url("' + (shown.img['600'] || shown.img['900']) + '")'; ui.dockImg.style.backgroundSize = 'cover'; }
        else { var logo = ui.dockOpen ? ui.dockOpen.getAttribute('data-logo') : ''; ui.dockImg.style.backgroundImage = logo ? 'url("' + logo + '")' : 'none'; ui.dockImg.style.backgroundSize = '56%'; }
      }
      syncErrors(miss, s);
      dockUpdate(s.typed);
    }

    /* ---------- errors: only the village is required (and who it is for, once a year is written) ---------- */
    function setErr(node, msg) { if (!node) return; if (msg) { setIf(node, msg); node.hidden = false; } else { node.hidden = true; } }
    function syncErrors(miss, s) {
      if (miss.indexOf('village') < 0) { setErr(ui.errAldeia, ''); f.v.removeAttribute('aria-invalid'); }
      if (miss.indexOf('para') < 0) setErr(ui.errPara, '');
      if (miss.indexOf('ano') < 0) { setErr(ui.errAno, ''); f.ano.removeAttribute('aria-invalid'); }
      else if (yearTouched) { setErr(ui.errAno, tpl('t-err-ano')); f.ano.setAttribute('aria-invalid', 'true'); }
    }
    function focusMissing() {
      var s = lines(), miss = missingList(s)[0], target = null, focusable = null;
      if (miss === 'village') { target = f.v; focusable = f.v; setErr(ui.errAldeia, tpl('t-err-aldeia')); f.v.setAttribute('aria-invalid', 'true'); }
      else if (miss === 'para') { target = ui.stepPara; focusable = ui.stepPara.querySelector('input'); setErr(ui.errPara, tpl('t-err-para')); }
      else if (miss === 'ano') { target = f.ano; focusable = f.ano; yearTouched = true; setErr(ui.errAno, tpl('t-err-ano')); f.ano.setAttribute('aria-invalid', 'true'); }
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 350);
    }

    /* ---------- submit: lock against a second press, start from an empty cart, then go to checkout ---------- */
    var sending = false, locked = [];
    function lock(on) {
      if (on) qa('.js-order').forEach(function (b) { if (!b.disabled) { b.disabled = true; locked.push(b); } b.setAttribute('aria-busy', 'true'); });
      else { locked.forEach(function (b) { b.disabled = false; }); locked = []; qa('.js-order').forEach(function (b) { b.removeAttribute('aria-busy'); }); }
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;
      render();   // the caption that is sent is the one on the frame, never an older one
      if (missingList(lines()).length) { focusMissing(); return; }
      sending = true; lock(true);
      var sent = false, proceed = function () { if (!sent) { sent = true; form.submit(); } };   // form.submit() does not raise this event again
      var url = A.getAttribute('data-cart-clear');
      // /cart/add adds to what is there: an earlier try, or a Back from checkout, would otherwise leave two frames in the cart
      if (window.fetch && url) { fetch(url, { method: 'POST', credentials: 'same-origin' }).then(proceed, proceed); setTimeout(proceed, 3000); } else { proceed(); }
    });
    // Back from checkout can restore this page from memory: let the buttons work again
    window.addEventListener('pageshow', function (e) { if (e.persisted) { sending = false; lock(false); } });

    /* ---------- events ---------- */
    f.v.addEventListener('input', function () {
      if (place && norm(place.f) !== norm(f.v.value) && !keepsTyped(f.v.value, place)) { place = null; setPlaceUI(null); }
      render();
    });
    f.cid.addEventListener('input', render); f.cid.addEventListener('change', render);
    f.ano.addEventListener('input', function () { var d = f.ano.value.replace(/\D/g, '').slice(0, 4); if (f.ano.value !== d) f.ano.value = d; render(); });
    f.ano.addEventListener('change', function () { yearTouched = true; render(); });
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'properties[Para quem]') voiceTouched = true;
      render();
    });
    // Return never sends the order (the form's default button is disabled). In the year it moves on to the city; in the city it ends the typing.
    f.ano.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.isComposing) { e.preventDefault(); f.cid.focus(); } });
    f.cid.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.isComposing && e.keyCode !== 229) setTimeout(function () { f.cid.blur(); }, 0); });
    var go = $('amt-go');
    if (go) go.addEventListener('click', function () {
      if (!(f.v.value || '').trim()) { f.v.focus(); return; }
      hideSugg();
      // on a phone the frame is what the buyer just earned: show it, with the first question under it
      if (narrow.matches && ui.wall) ui.wall.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else ui.stepPara.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = ui.stepPara.querySelector('input'); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
    });
    // on a phone, bring the field to the top when it is tapped, so the keyboard does not cover the suggestions
    f.v.addEventListener('focus', function () {
      if (!narrow.matches) return;
      var ask = f.v.closest('.ask'), r = ask ? ask.getBoundingClientRect() : null;
      if (r && (r.top > 150 || r.top < 0)) setTimeout(function () { ask.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
    });
    // leaving the field is the pause that lets the answer appear
    f.v.addEventListener('blur', function () { updateAnswer(); });
    if (ui.lastFind) ui.lastFind.addEventListener('click', function () { f.v.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { f.v.focus({ preventScroll: true }); }, 450); });
    if (ui.fmtSwitch) qa('button', ui.fmtSwitch).forEach(function (b) {
      b.addEventListener('click', function () {
        var r = form.querySelector('input[name="id"][data-k="' + b.getAttribute('data-fmt') + '"]');
        if (r) { r.checked = true; render(); }
      });
    });
    if (ui.dockOpen && ui.wall) ui.dockOpen.addEventListener('click', function () { ui.wall.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    /* ---------- the villages we have photographed ---------- */
    if (ui.ex && VILLAGES.length >= 2) {
      VILLAGES.forEach(function (v) {
        var li = document.createElement('li'), b = document.createElement('button');
        b.type = 'button'; b.className = 'ex__item'; b.setAttribute('aria-pressed', 'false');
        var t = document.createElement('span'); t.className = 'ex__thumb'; t.style.backgroundImage = 'url("' + (v.img['600'] || v.img['900']) + '")';
        var n = document.createElement('span'); n.className = 'ex__name'; n.textContent = v.name;
        b.appendChild(t); b.appendChild(n); li.appendChild(b); ui.exList.appendChild(li);
        exBtns.push({ b: b, v: v });
        b.addEventListener('click', function () {
          f.v.value = v.name; place = null; setPlaceUI(null); hideSugg(); render();
          var r = ui.wall.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) ui.wall.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      ui.ex.hidden = false;
    }

    /* ---------- state from the link: a group tag, a source, and a caption filled in by someone else ---------- */
    var Q = new URLSearchParams(location.search);
    if ($('p-grupo')) $('p-grupo').value = Q.get('v') || '';
    if ($('p-origem')) $('p-origem').value = Q.get('src') || Q.get('utm_campaign') || '';
    if ($('p-lingua')) $('p-lingua').value = L;
    if (Q.get('aldeia')) {
      f.v.value = Q.get('aldeia').slice(0, 60);
      if (Q.get('ano')) f.ano.value = Q.get('ano').replace(/\D/g, '').slice(0, 4);
      if (Q.get('cidade')) f.cid.value = Q.get('cidade').slice(0, 40);
      // only known answers are looked up: a stray quote in a forwarded link must not reach a selector
      var rawP = Q.get('para'), pk = Object.prototype.hasOwnProperty.call(OLD_PARA, rawP) ? OLD_PARA[rawP] : rawP;
      if (PARAS.indexOf(pk) > -1) { var pr = form.querySelector('input[name="properties[Para quem]"][data-k="' + pk + '"]'); if (pr) pr.checked = true; }
      var lk = Q.get('leg');
      if (LEGS.indexOf(lk) > -1) { var lr = form.querySelector('input[name="properties[Tipo de legenda]"][data-k="' + lk + '"]'); if (lr) lr.checked = true; }
      if (ui.banner) ui.banner.hidden = false;
    }
    // the link a buyer forwards carries the caption (village, year, city), a source mark, and nothing else
    if (ui.share) ui.share.addEventListener('click', function () {
      var s = lines(), p = new URLSearchParams();
      p.set('aldeia', f.v.value.trim()); if (s.ano) p.set('ano', s.ano); if (f.cid.value.trim()) p.set('cidade', f.cid.value.trim());
      if (s.p) p.set('para', s.p); p.set('leg', s.k); p.set('src', 'partilha');
      window.open('https://wa.me/?text=' + encodeURIComponent(location.origin + location.pathname + '?' + p.toString()), '_blank', 'noopener');
    });

    /* Facebook's and Instagram's in-app browsers: the Apple Pay line */
    if (/FBAN|FBAV|FB_IAB|FBIOS|Instagram/.test(navigator.userAgent)) qa('.js-fb').forEach(function (n) { n.hidden = false; });

    /* ---------- the bar at the bottom (phones and tablets): shown once a village is chosen and neither the first screen, the frame nor an order block is in view ---------- */
    var seen = {}, dockTimer = null;
    function dockUpdate(typed) {
      var d = ui.dock; if (!d) return;
      var inView = Object.keys(seen).some(function (k) { return seen[k]; });
      if (typed && !inView) {
        clearTimeout(dockTimer); d.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-up'); }); });
      } else {
        d.classList.remove('is-up');
        clearTimeout(dockTimer);
        dockTimer = setTimeout(function () { if (!d.classList.contains('is-up')) d.hidden = true; }, 350);
      }
    }
    if (ui.dock && 'IntersectionObserver' in window) {
      var bio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { seen[e.target.getAttribute('data-obs')] = e.isIntersecting; });
        dockUpdate(!!(f.v.value || '').trim());
      });
      qa('.hero, #wall, .buy--flow, #amt-last').forEach(function (n, i) { n.setAttribute('data-obs', 'o' + i); bio.observe(n); });
      seen.o0 = true;   // the first screen is what a page opens on: the bar must not flash before the observer has looked
    }

    /* ---------- places: distrito > concelho > freguesia, typed or picked from three lists ---------- */
    var PLACES = null, INDEX = [], loading = null, active = -1, shownList = [];
    var selD = $('amt-d'), selC = $('amt-c'), selF = $('amt-f'), placeP = $('amt-place'), placeT = $('amt-place-txt'), pickBox = $('amt-pick');
    var sugg = ui.sugg;
    function opt(sel, list) { sel.length = 1; list.forEach(function (n) { var o = document.createElement('option'); o.value = n; o.textContent = n; sel.appendChild(o); }); sel.disabled = !list.length; }
    function byName(a, b) { return a.localeCompare(b, 'pt'); }
    function loadPlaces() {
      if (loading) return loading;
      var url = A.getAttribute('data-places'); if (!url || !window.fetch) return (loading = Promise.resolve());
      loading = fetch(url).then(function (r) { if (!r.ok) throw new Error('places'); return r.json(); }).then(function (d) {
        PLACES = d;
        Object.keys(d).forEach(function (di) { Object.keys(d[di]).forEach(function (co) { d[di][co].forEach(function (fr) { INDEX.push({ f: fr, c: co, d: di, n: norm(fr), nc: norm(co) }); }); }); });
        if (selD) opt(selD, Object.keys(d).sort(byName));
        if (pickBox) pickBox.hidden = false;
        if (place) syncSelects();
      }).catch(function () { loading = null; if (pickBox) pickBox.hidden = true; });   // the next time the field is used it tries again
      return loading;
    }
    function syncSelects() {
      if (!PLACES || !selD || !place || !PLACES[place.d]) return;
      selD.value = place.d; opt(selC, Object.keys(PLACES[place.d]).sort(byName)); selC.value = place.c;
      opt(selF, (PLACES[place.d][place.c] || []).slice().sort(byName)); selF.value = place.f;
    }
    function setPlaceUI(p) {
      if (placeP) { placeP.hidden = !p; if (p) placeT.textContent = p.f + ' · ' + p.c + ' · ' + p.d; }
      if (!p && selD) { selD.value = ''; opt(selC, []); opt(selF, []); }
    }
    // If the buyer typed the name their family uses (a whole word or more of the official name), keep it: it is what gets printed.
    function keepsTyped(typed, p) {
      var t = norm(typed), o = norm(p.f);
      return !!t && (t === o || (o.indexOf(t) === 0 && o.charAt(t.length) === ' '));
    }
    function setPlace(p, fromList) {
      var typed = (f.v.value || '').trim();
      place = p;
      if (fromList || !typed || !keepsTyped(typed, p)) f.v.value = p.f;
      setPlaceUI(p); syncSelects(); hideSugg(); render();
    }
    function hideSugg() {
      if (!sugg) return;
      var was = !sugg.hidden;
      sugg.hidden = true; sugg.textContent = ''; shownList = []; active = -1;
      f.v.setAttribute('aria-expanded', 'false'); f.v.removeAttribute('aria-activedescendant');
      if (was) updateAnswer();
    }
    function showSugg() {
      if (!sugg || document.activeElement !== f.v) return;   // the list may have been asked for before the buyer left the field
      var qn = norm(f.v.value); if (qn.length < 2 || !INDEX.length) { hideSugg(); return; }
      var hits = [];
      for (var i = 0; i < INDEX.length; i++) {
        var it0 = INDEX[i], k = it0.n.indexOf(qn), rank = -1;
        if (it0.n === qn) rank = 0; else if (k === 0) rank = 1; else if (k > 0) rank = 2; else if (it0.nc.indexOf(qn) === 0) rank = 3;
        if (rank > -1) hits.push({ it: it0, r: rank });
      }
      // the name typed in full comes first, then names that start with it, then names that contain it, then places in a concelho of that name
      hits.sort(function (a, b) { return a.r - b.r || a.it.n.length - b.it.n.length || (a.it.f < b.it.f ? -1 : a.it.f > b.it.f ? 1 : 0); });
      shownList = hits.slice(0, 8).map(function (h) { return h.it; }); active = -1; sugg.textContent = ''; f.v.removeAttribute('aria-activedescendant');
      if (!shownList.length || (place && norm(place.f) === qn)) { hideSugg(); return; }
      shownList.forEach(function (it, i) {
        var li = document.createElement('li'); li.id = 'amt-sugg-' + i; li.setAttribute('role', 'option'); li.setAttribute('aria-selected', 'false');
        var a = document.createElement('span'); a.textContent = it.f; var b = document.createElement('span'); b.className = 'sugg__where'; b.textContent = it.c + ', ' + it.d;
        li.appendChild(a); li.appendChild(b);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); });          // keep the focus in the field
        li.addEventListener('click', function () { setPlace(it, false); });              // a mouse, a finger, a screen reader and a switch all end in a click
        sugg.appendChild(li);
      });
      sugg.hidden = false; f.v.setAttribute('aria-expanded', 'true');
      updateAnswer();
    }
    function mark(i) {
      active = i; Array.prototype.forEach.call(sugg.children, function (li, k) { li.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (i >= 0) { f.v.setAttribute('aria-activedescendant', 'amt-sugg-' + i); if (sugg.children[i].scrollIntoView) sugg.children[i].scrollIntoView({ block: 'nearest' }); }
      else f.v.removeAttribute('aria-activedescendant');
    }
    if (f.v && sugg) {
      f.v.addEventListener('focus', loadPlaces);
      f.v.addEventListener('input', function () { loadPlaces().then(showSugg); });
      f.v.addEventListener('blur', function () { setTimeout(hideSugg, 120); });
      // one handler for the keys of the field: the list when it is open, the next question when it is not
      f.v.addEventListener('keydown', function (e) {
        if (e.isComposing || e.keyCode === 229) return;   // a word still being composed (an input method) is not finished
        var open = !sugg.hidden && shownList.length;
        if (open && e.key === 'ArrowDown') { e.preventDefault(); mark((active + 1) % shownList.length); }
        else if (open && e.key === 'ArrowUp') { e.preventDefault(); mark(active <= 0 ? shownList.length - 1 : active - 1); }
        else if (open && e.key === 'Escape') { hideSugg(); }
        else if (e.key === 'Enter') { e.preventDefault(); if (open && active >= 0) setPlace(shownList[active], false); else if (go) go.click(); }
      });
    }
    if (pickBox) pickBox.addEventListener('toggle', function () { if (pickBox.open) loadPlaces(); });
    if (selD) selD.addEventListener('change', function () { opt(selC, selD.value && PLACES ? Object.keys(PLACES[selD.value]).sort(byName) : []); opt(selF, []); });
    if (selC) selC.addEventListener('change', function () { opt(selF, selC.value ? PLACES[selD.value][selC.value].slice().sort(byName) : []); });
    if (selF) selF.addEventListener('change', function () { if (selF.value) setPlace({ f: selF.value, c: selC.value, d: selD.value }, true); });
    var px = $('amt-place-x'); if (px) px.addEventListener('click', function () { place = null; setPlaceUI(null); render(); });

    render();
  }
})();
